<template>
  <div class="equipment-filters bg-white p-4 rounded-lg shadow-sm">
    <h3 class="text-lg font-semibold mb-4">Filters</h3>

    <div class="space-y-4">
      <!-- Status Filter -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Status</label>
        <select v-model="filters.status" class="w-full p-2 border border-gray-300 rounded-md">
          <option value="">All Status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="maintenance">Maintenance</option>
        </select>
      </div>

      <!-- Fuel Type Filter -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Fuel Requirement</label>
        <select
          v-model="filters.requires_fuel"
          class="w-full p-2 border border-gray-300 rounded-md"
        >
          <option value="">All Equipment</option>
          <option value="true">Requires Fuel</option>
          <option value="false">No Fuel Required</option>
        </select>
      </div>

      <!-- Equipment Type Filter -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Equipment Type</label>
        <select v-model="filters.type" class="w-full p-2 border border-gray-300 rounded-md">
          <option value="">All Types</option>
          <option v-for="type in equipmentTypes" :key="type" :value="type">
            {{ type }}
          </option>
        </select>
      </div>

      <!-- Search -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Search</label>
        <input
          v-model="filters.search"
          placeholder="Search by name or model..."
          class="w-full p-2 border border-gray-300 rounded-md"
        />
      </div>

      <!-- Action Buttons -->
      <div class="flex space-x-2 pt-2">
        <button @click="applyFilters" class="btn-primary flex-1">Apply Filters</button>
        <button @click="resetFilters" class="btn-secondary flex-1">Reset</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useEquipmentStore } from '@/stores/equipmentStore'

type StatusType = 'active' | 'inactive' | 'maintenance'
interface Filters {
  status: StatusType | ''
  requires_fuel: string
  type: string
  search: string
}

const emit = defineEmits<{
  (
    e: 'filter',
    filters: Partial<{ status: StatusType; requires_fuel: boolean; type: string; search?: string }>,
  ): void
}>()

const equipmentStore = useEquipmentStore()
const filters = ref<Filters>({
  status: '',
  requires_fuel: '',
  type: '',
  search: '',
})

const equipmentTypes = computed(() => {
  const types = new Set(equipmentStore.equipment.map((eq) => eq.type))
  return Array.from(types).sort()
})

const applyFilters = () => {
  const appliedFilters = {
    status: (filters.value.status || undefined) as StatusType | undefined,
    requires_fuel: filters.value.requires_fuel ? filters.value.requires_fuel === 'true' : undefined,
    type: filters.value.type || undefined,
    search: filters.value.search || undefined,
  }
  emit('filter', appliedFilters)
}

const resetFilters = () => {
  filters.value = {
    status: '',
    requires_fuel: '',
    type: '',
    search: '',
  }
  emit('filter', {})
}
</script>
